import { COMMON_DATE_FORMAT } from 'constants/date';
import { formatDate } from 'utils/date';

/**
 * Main badge copy for a possible-duplicate segment. Includes the prior
 * upload date when the backend provides one.
 *
 * @param {{ jobId: string, documentId?: string|null, filedDate?: string|null }|null} duplicateOf
 * @returns {string}
 */
export const formatDuplicateBadgeText = duplicateOf => {
  if (!duplicateOf?.filedDate) {
    return 'Possible duplicate — already uploaded';
  }

  return `Possible duplicate — already uploaded ${formatDate(
    duplicateOf.filedDate,
    COMMON_DATE_FORMAT,
  )}`;
};

/**
 * State suffix reflecting the segment's current file-toggle: duplicates are
 * skipped by default, and the copy flips when the user re-enables filing.
 *
 * @param {boolean} isSelected
 * @returns {string}
 */
export const formatDuplicateStatusText = isSelected =>
  isSelected ? '· filing anyway' : '· skipped';
